.link {
  transition: text-decoration-color 150ms ease;
}

.link:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
  border-radius: 2px;
}

.underlineHover:hover {
  text-decoration: underline;
}
